import {
  GET_LIST_CONGNOTHANHLY,
  GET_LIST_CONGNOTHANHLY_SUCCESS,
  GET_LIST_CONGNOTHANHLY_FAILURE,
} from "../../actions/CongNoThanhLy/actionTypes";

const initialState = {
  List: [],
  TongTienThu: 0,
  TongTienDaTra: 0,
  TongTienConNo: 0,
  TotalQuantity: 0,
  getListCongNoThanhLyLoading: false,
};
const getListCongNoThanhLy = (state, action) => ({
  ...state,
  getListCongNoThanhLyLoading: true,
});

const getListCongNoThanhLySuccess = (state, action) => {
  // console.log(action);
  return {
    ...state,
    List: action.payload.List,
    TotalQuantity: action.payload.TotalQuantity,
    TongTienThu: action.payload.TongTienThu,
    TongTienDaTra: action.payload.TongTienDaTra,
    TongTienConNo: action.payload.TongTienConNo,
    getListCongNoThanhLyLoading: false,
  };
};

const getListCongNoThanhLyFailed = (state, action) => ({
  ...state,
  getListCongNoThanhLyLoading: false,
  List: [],
});
export const listCongNoThanhLyReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_CONGNOTHANHLY:
      return getListCongNoThanhLy(state, action);
    case GET_LIST_CONGNOTHANHLY_SUCCESS:
      // alert("tuty");
      return getListCongNoThanhLySuccess(state, action);
    case GET_LIST_CONGNOTHANHLY_FAILURE:
      //alert('false')
      return getListCongNoThanhLyFailed(state, action);
    default:
      return state;
  }
};

export default listCongNoThanhLyReducer;
